// ABOUTME: Orders companies by the names shown in the company switcher.
// ABOUTME: Keeps authenticated company data unchanged for other consumers.
export const getCompaniesInAlphabeticalOrder = (companies: Compleo.IObject[]) =>
    [...companies].sort((firstCompany, secondCompany) =>
        firstCompany.CompanyFancyName.localeCompare(
            secondCompany.CompanyFancyName,
            undefined,
            { sensitivity: "base" }
        )
    );
